package com.gsb.vyapar.bhagya.presentation

sealed class Screens {
    data object Splash : Screens()
    data object Navigation : Screens()
    data object Home : Screens()
    data object Categories : Screens()
    data object Favorites : Screens()
    data object Latest : Screens()
    data object Category : Screens()
    data object AddCategory : Screens()
    data object AdminCategories : Screens()
    data object InfoScreen : Screens()
    data object ConfigScreen : Screens()
    data object Login : Screens()
    data object Register : Screens()
    data object About : Screens()
    data object ManageBusiness : Screens()
    data object AddEditBusiness : Screens()
    data object AdminView : Screens()
    data object ReviewBusiness : Screens()
    data object BusinessDetail : Screens()
    data object BusinessMap : Screens()
    data object Search : Screens()
    data object Gallery : Screens()
    data object PasswordLogin : Screens()
    data object GetUser : Screens()
    data object SearchList : Screens()
}